import { computed } from 'vue';
import { useKradv2InputStore } from '@/features/Sparten/kradv2/useInputStore';
import { WKZ } from '@/features/Sparten/shared/types/kfz/types';

export const isWkz003 = computed(
  (): boolean =>
    useKradv2InputStore().allgemein !== undefined &&
    useKradv2InputStore().allgemein.wkz === WKZ.KRAFTRAEDER_KRAFTROLLER,
);
